import React from "react";
import LeftAside from "../reusable/Leftaside";
import {
  TRAINING_CARDS_1,
  TRAINING_CARDS_2,
  TRAINING_HERO,
  TRAINING_BOTTOM_CONTENT,
} from "../utils/constants";
import PageDesc from '../reusable/PageDesc'
import Cards from "../reusable/Cards";
import "../Styles/training.css";

const Training = () => {
  return (
    <div className="outlet-render">
      <LeftAside {...TRAINING_HERO} />
      <div className="training-main-cards">
        <div className="training-cards-heading">
          <h2 className="training-title">
            Ready to Master IT in Just 6 Months?
          </h2>
          <h1 className="training-subtitle">
            Master In-Demand Skills in 6 Months
          </h1>
        </div>
        <div className="training-cards">
          {TRAINING_CARDS_1.map((item) => {
            return <Cards {...item} />;
          })}
        </div>
      </div>
      <div className="training-main-cards">
        <div className="training-cards-heading">
          <h2 className="training-title">
            Ready to Boost Your IT Skills in Just 3 Months?
          </h2>
          <h1 className="training-subtitle">
            Master Essential IT Skills in 3 Months
          </h1>
        </div>
        <div className="training-cards">
          {TRAINING_CARDS_2.map((item) => {
            return <Cards {...item} />;
          })}
        </div>
      </div>
      <PageDesc {...TRAINING_BOTTOM_CONTENT}/>

    </div>
  );
};

export default Training;
